import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Divider, Tooltip } from "antd";
import moment from "moment";

import WidgetCardTooltip from "./WidgetCardTooltip";
import { ReactComponent as MoreIcon } from "../../../assets/svg/more.svg";
import placeholderImg from "../../../assets/images/imagePlaceholder.png";
import { Http } from "../../../helpers/axois"
import { useToast } from '../../../helpers/commonFunction';

import "./styles/widget-card.scss";
import { GCPENDPOINT } from "../../../constant/common";
import { useHistory } from "react-router-dom";
import { logger } from "../../../constant/winston";
import { AppState } from "../../../stateManager/store";

export type Widget = {
  id: string;
  org_id: string;
  build_id: string;
  name: string;
  title: string;
  description: string;
  screenshots: null;
  is_paid: boolean;
  is_published: boolean;
  preview_image: null;
  meta_data: null;
  tags: null;
  object_url: string;
  version_tag: string;
  author_website: null;
  support_email: null;
  first_name: string;
  last_name: string;
  updated_at: string;
  is_installed: boolean;
};

export interface IProps {
  widget: Widget;
  deleteproduct: (id: string) => void;
  handleWidgetStatus: (widgetId: string, status: boolean) => void;
  editAccess:boolean
}

const WidgetCard: React.FC<IProps> = ({ widget, deleteproduct, handleWidgetStatus, editAccess }) => {
  const selectedOrgId = useSelector((state: any) => state.org.selectedOrg.id)
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const history = useHistory();
  const { SuccessToast, ErrorToast } = useToast();
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })


  const handleClick = (e: { stopPropagation: () => void; }) => {
    e.stopPropagation();
    history.push(`/marketplace/widgets/widgetPreview/${widget.id}`);
  };

  const handleWidgetInstall = async (e: { stopPropagation: () => void; }) => {
    e.stopPropagation();
        if ((!orgPermissions?.includes("marketplace.PublishWidget") || !orgPermissions.includes('org.View')) && loggedInUserId!=selectedOrg?.owner) {
          ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      return
    }
    if (!widget.is_installed) {
      const endpoint = `/orgs/${selectedOrgId}/store/products/${widget.id}/install`
      try {
        await Http.post(endpoint).toPromise();
        handleWidgetStatus(widget.id, true)
        SuccessToast(`Installed ${widget.name}`)
      } catch (err) {
        if (err === "Forbidden") {
          ErrorToast("Not Authorized: Please request owner of this organization to provide access")
        } else {
        ErrorToast("Failed to install widget")
      }
        logger.error(err)
      }
    }
  }

  return (
    <div className="widget-card-container">
      <div data-test-id="widget_card" className="widget-card" role="presentation" onClick={handleClick}>
        <div style={{ maxHeight: "151px" }}>  
          <div className='img-title-desc-container'>
              <div  className='image-container' >
                <img
                  src={
                    widget.preview_image
                      ? `${(widget?.preview_image || "").startsWith("https://") ? widget.preview_image : GCPENDPOINT+widget.preview_image}`
                      : placeholderImg
                  }
                  alt="icon"
                />
              </div>
              <div className="info">
                <h4 className="hl truncate text-ellipsis w-90% mr-3.5 text-lg pr-3.5 break-all" title={widget.name}>{widget.name}</h4>
                <p className="truncate-text" title={widget?.description}>{widget?.description}</p>
              </div>
              <button className="widget-more-icon">
                <Tooltip
                  className="more"
                  onVisibleChange={setTooltipVisible}
                  visible={tooltipVisible}
                  placement="topLeft"
                  overlayClassName="widgetCardTooltip"
                  title={
                    <WidgetCardTooltip
                      widget={widget}
                      setTooltipVisible={setTooltipVisible}
                      deleteproduct={deleteproduct}
                      install={widget.is_installed}
                      handleWidgetStatus={handleWidgetStatus}
                      editAccess={editAccess}
                    />
                  }
                  trigger="click"
                >
                  <MoreIcon height="16px" />
                </Tooltip>
              </button>
          </div>
          <div className="author-install">
            <p>
              By:{" "}
              <span className="hl">
                {widget.first_name} {widget.last_name}
              </span>
            </p>
            <button
              data-test-id={`${widget.is_installed ? "Installed" : "Install"}`}
              onClick={handleWidgetInstall}
              className={`${widget.is_installed ? "btn-installed" : "btn-install"
                }`}
            >
              {widget.is_installed ? "Installed" : "Install"}
            </button>
          </div>

          <Divider style={{ margin: "5px 0" }} />
        </div>
        <div className="meta-info">
          <p className={`type ${widget.is_paid ? "paid" : ""}`}>
            {widget.is_paid ? "Paid" : "Free"}
          </p>
          <div className="version-updated">
            <p>
              Version: <span className="hl">{widget.version_tag}</span>
            </p>
            <p>
              Last updated:{" "}
              <span className="hl">
                {moment(widget.updated_at).format("MMM Do YYYY")}
              </span>
            </p>
          </div>
          </div>
        </div>
    </div>
  );
};

export default WidgetCard;
